export default "__VITE_ASSET__Dt4LYmUp__"